import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-white p-4 px-6 border" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-2 items-center justify-center text-sm select-none"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Загрузка данных...", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-red-500" }, "Произошла ошибка при получении данных", -1)
const _hoisted_5 = {
  key: 1,
  class: "flex items-start justify-between"
}
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = {
  key: 0,
  width: "18",
  height: "12",
  viewBox: "0 0 18 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.6234 0.351472C18.1255 0.820101 18.1255 1.5799 17.6234 2.04853L7.33771 11.6485C6.83561 12.1172 6.02154 12.1172 5.51943 11.6485L0.376577 6.84853C-0.125526 6.3799 -0.125526 5.6201 0.376577 5.15147C0.87868 4.68284 1.69275 4.68284 2.19485 5.15147L6.42857 9.10294L15.8051 0.351472C16.3073 -0.117157 17.1213 -0.117157 17.6234 0.351472Z",
  fill: "#25943F"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 6V10L13 13M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
  stroke: "#A0A0A0",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "text-sm text-gray-600" }
const _hoisted_14 = { class: "flex flex-col items-end justify-between gap-6" }
const _hoisted_15 = { class: "flex items-center gap-5" }
const _hoisted_16 = { class: "text-sm text-gray-500" }
const _hoisted_17 = { class: "text-sm bg-gray-100 px-3 py-2 rounded-2xl text-gray-600" }
const _hoisted_18 = { class: "flex items-center justify-end mt-3 gap-5" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1)
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading || _ctx.failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_3
              ], 64))
            : (_ctx.failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createVNode(_component_the_button, { class: "primary small" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Перезагрузить")
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : (Boolean(_ctx.bid))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bid.signers, (signer) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex items-center gap-5",
                  key: signer.id
                }, [
                  _createElementVNode("div", null, [
                    (signer.isSigned)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_9))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
                  ]),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(signer.email), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-xs px-3 py-1 rounded-2xl select-none", {
                            'bg-green-100 border border-green-500 text-green-600': signer.isSigned,
                            'bg-gray-100 border border-gray-400 text-gray-600': !signer.isSigned,
                        }])
                  }, [
                    (signer.isSigned)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(signer.typeId === 1 ? 'Подписано' : 'Согласовано'), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(signer.typeId === 1 ? 'Не подписано' : 'Не согласовано'), 1)
                        ], 64))
                  ], 2)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, " Отправлен на подписание: " + _toDisplayString(_ctx.bid.createdAt), 1),
                _createElementVNode("div", _hoisted_17, " ID: " + _toDisplayString(_ctx.bid.id), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_the_button, {
        class: "primary small",
        loading: _ctx.actionsLoading,
        onClick: _ctx.onUpdate,
        hint: "Редактировать подписантов"
      }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      }, 8, ["loading", "onClick"]),
      _createElementVNode("a", {
        target: "_blank",
        rel: "noreferrer noopener",
        href: _ctx.bid.dogovor24Url
      }, [
        _createVNode(_component_the_button, {
          class: "primary small",
          hint: "Ссылка на Договор24"
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        })
      ], 8, _hoisted_20),
      _createVNode(_component_the_button, {
        class: "primary small",
        loading: _ctx.actionsLoading,
        onClick: _ctx.onCheck,
        hint: "Проверка договора"
      }, {
        default: _withCtx(() => [
          _hoisted_22
        ]),
        _: 1
      }, 8, ["loading", "onClick"]),
      _createVNode(_component_the_button, {
        class: "red small",
        loading: _ctx.actionsLoading,
        onClick: _ctx.onDelete,
        hint: "Удалить заявку"
      }, {
        default: _withCtx(() => [
          _hoisted_23
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}